import ProjectsChart from './projects_chart'

export default ProjectsChart
